import {
  styled,
  motion,
  Img,
  colors,
  breakpoints,
  typo,
} from '../../styles/base/_allBase.styles'

// Breakpoints
const {
  xxSmallDevices,
  xxSmallDevicesLandscape,
  extraSmallDevices,
  extraSmallDevicesLandscape,
  mediumDevices,
  mediumDevicesLandscape,
  largeDevices,
  extraLargeDevices,
  xxLargeDevices,
} = breakpoints

export const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  ${
    '' /* background: ${(props) => (props.inherit === true ? 'inherit' : props.theme.colors.contrast)}; */
  }
  cursor: auto;
  opacity: 1;
  z-index: 0;
  overflow: hidden;

  &:focus-visible {
    outline: 3px solid ${(props) => props.theme.colors.warm.tertiary};
    outline-offset: 4px;
  }

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const NavigationButton = styled.button`
  position: absolute;
  top: 50%;
  ${({ $side }) => ($side === 'left' ? 'left: 1.25rem;' : 'right: 1.25rem;')}
  transform: translateY(-50%);
  display: grid;
  place-items: center;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.65);
  border-radius: 50%;
  background: rgba(24,47,53, 0.82);
  box-shadow: 0 0.5rem 1.5rem rgba(24,47,53, 0.24);
  color: white;
  cursor: pointer;
  font: inherit;
  z-index: 120;
  transition: background 180ms ease, transform 180ms ease;

  span {
    display: block;
    margin-top: -0.2rem;
    font-size: 2.6rem;
    font-weight: 300;
    line-height: 1;
  }

  &:hover,
  &:focus-visible {
    background: ${(props) => props.theme.colors.warm.secondary};
    outline: none;
    transform: translateY(-50%) scale(1.06);
  }

  @media ${xxSmallDevices} {
    ${({ $side }) => ($side === 'left' ? 'left: 0.75rem;' : 'right: 0.75rem;')}
    width: 3rem;
    height: 3rem;

    span {
      font-size: 2.2rem;
    }
  }
`

export const Pagination = styled.div`
  position: absolute;
  left: 50%;
  bottom: 1.25rem;
  display: flex;
  gap: 0.55rem;
  padding: 0.7rem 0.85rem;
  border-radius: 999px;
  background: rgba(24,47,53, 0.76);
  transform: translateX(-50%);
  z-index: 120;
`

export const PaginationDot = styled.button`
  width: ${({ $active }) => ($active ? '1.7rem' : '0.65rem')};
  height: 0.65rem;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.warm.tertiary : 'rgba(255, 255, 255, 0.72)'};
  cursor: pointer;
  transition: width 180ms ease, background 180ms ease;

  &:focus-visible {
    outline: 2px solid white;
    outline-offset: 3px;
  }
`

export const SlideCount = styled.div`
  position: absolute;
  right: 1.25rem;
  bottom: 1.25rem;
  padding: 0.6rem 0.8rem;
  border-radius: 999px;
  background: rgba(24,47,53, 0.76);
  color: white;
  font-size: 0.78rem;
  letter-spacing: 0.05em;
  z-index: 120;

  @media ${xxSmallDevices} {
    display: none;
  }
`

export const HalfScreenButton = styled.div`
  width: 100%;
  height: 100%;
  border: 1rem solid green;
  opacity: 0.5;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const Cursor = styled(motion.div)`
  display: none;
  ${
    '' /* visible: ${(props) => (props.visible === true ? 'true' : 'false')}; */
  }
  position: fixed;
  left: 0;
  top: 0;
  width: 5rem;
  height: 5rem;
  border-radius: 7rem;
  background-color: ${(props) => props.theme.colors.warm.secondary};
  border: 1.25rem solid ${(props) => props.theme.colors.warm.secondary};
  mix-blend-mode: difference;
  z-index: 999;
  pointer-events: none;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const StyledLeftArrow = styled.svg`
  width: 100%;
  height: 100%;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const ButtonDiv = styled(motion.div)`
  height: 100%;
  width: 50%;
  left: ${(props) => (props.right ? '50%' : '0%')};
  position: absolute;
  z-index: 100;
  ${'' /* background: ${(props) => (props.right ? 'blue' : 'red')}; */}
  opacity: 1;
  object-fit: cover;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`

export const StackedContainer = styled(motion.div)`
  position: absolute;
  left: 0;
  height: 100%;
  width: 100%;
  -webkit-transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -o-transition: opacity 1s ease-in-out;
  transition: opacity 1s ease-in-out;

  @media ${xxSmallDevices} {
  }
  @media ${xxSmallDevicesLandscape} {
  }
  @media ${extraSmallDevices} {
  }
  @media ${extraSmallDevicesLandscape} {
  }
  @media ${mediumDevices} {
  }
  @media ${mediumDevicesLandscape} {
  }
  @media ${largeDevices} {
  }
  @media ${extraLargeDevices} {
  }
  @media ${xxLargeDevices} {
  }
`
